import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Partner} from '../../../shared/api/model/partner';
import {Product} from '../../../shared/api/model/product';
import * as moment from 'moment';
import {IventoryService} from '../../../shared/api/resources/iventory/iventory.service';
import {SupplierService} from '../../../shared/api/resources/supplier/supplier.service';
import {environment} from '../../../../environments/environment';
import {StaticUtils} from '../../../shared/utils/static-utils';

@Component({
  selector: 'app-product-details',
  templateUrl: './product-details.component.html',
  styleUrls: ['./product-details.component.scss'],
  providers: []
})

export class ProductDetailsComponent implements OnInit {
  private _sub: any;
  moment = moment;
  partnerId: number;
  productId: number;
  partner: Partner;
  product: Product;
  version = environment.version;
  utils = StaticUtils;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _iventoryService: IventoryService,
    private _supplierService: SupplierService) { }

  ngOnInit() {
    this._sub = this._route.params.subscribe(params => {
      this.partnerId = parseInt(params['id'], 10);
      this.productId = parseInt(params['productId'], 10);

      this._supplierService
        .getAnonymSupplier(this.partnerId)
        .subscribe((partner: Partner) => this.partner = partner);

      this._iventoryService
        .getAnonymProductDetailById(this.partnerId, this.productId)
        .subscribe((product: Product) => this.product = product);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/experiences/products/product-details/product-details.component.ts